import React, { useState } from "react";
import "./AboutIntro.css";

const AboutIntro = () => {
  const [expanded, setExpanded] = useState(false);

  const shortText = `
 Blueberry DMC delivers end-to-end destination management services across, the Maldives, the UAE, India, Qatar, Singapore, Malaysia, and key African destinations, including Kenya, Tanzania, South Africa, Zimbabwe, and Zambia. 
  `;

  const fullText = `
Blueberry DMC delivers end-to-end destination management services across, the Maldives, the UAE, India, Qatar, Singapore, Malaysia, and key African destinations, including Kenya, Tanzania, South Africa, Zimbabwe, and Zambia.
 
Whether it's securing availability on peak dates or aligning multiple services across destinations without delays, every itinerary is handled end-to-end, from initial confirmations to the precise coordination of arrivals, intercity movements, and scheduled experiences, ensuring continuity at every stage.
  `;

  return (
    <section className="standard-padding AboutIntro-div mobile-padding-top">
        <h2 className="heading mb-4">
         End-to-End DMC Support Across Key Global Destinations 
        </h2>

        <h3 className="subtitle">
         From City Stays to Safari Circuits, Managed on the Ground 
        </h3>

        <p className="description">
          {expanded ? fullText : shortText}

          <span
            className="read-more"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? " Read less" : " Read more"}
          </span>
        </p>
    </section>
  );
};

export default AboutIntro;